import { AfterViewChecked, AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { QuillEditorComponent } from 'ngx-quill';
import { Complaint, ComplaintDetails, ICandidate } from 'src/app/interface/dto';
import { ComplaintService } from 'src/app/services/complaint-services.service';
import { AuthService } from 'src/app/services/http-services/authservice.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { Util } from 'src/app/services/Util';

@Component({
  selector: 'app-view-complaint',
  templateUrl: './view-complaint.component.html',
  styleUrls: ['./view-complaint.component.scss']
})
export class ViewComplaintComponent implements OnInit, AfterViewInit, AfterViewChecked {


  complaintID: any;
  complaintDetails: ComplaintDetails | any;
  response: string;
  complaint: Complaint = {
    complaintID: '',
    examNo: '',
    examinationID: 0,
    examinationScheduleID: 0,
    attempt: 0,
    categoryID: '',
    status: '',
    closedDate: undefined,
    submittedDate: undefined
  };
  toast = {
    visible: false,
    x: 0,
    y: 0
  };
  closeCM = false;
  @ViewChild('responseContainer') private responseContainer!: ElementRef;
  quill: any = {};
  @ViewChild('editor') editor: QuillEditorComponent;
  constructor(private complaintService: ComplaintService, private snackBar: SnackbarService,private authService: AuthService) { }

  async ngOnInit() {
    try {
      this.complaint = this.complaintService.selectedComplaints[0];
      this.complaintID = this.complaint.complaintID;
      this.complaintDetails = await this.complaintService.getComplaintDetails(this.complaint);
      const localClosedDate = Util.convertUTCToTimezone(this.complaintDetails.closedDate,this.authService.user.timezoneOffset);
      this.complaintDetails.closedDate = Util.toLocalInputValue(localClosedDate) as any;
      const localSubmittedDate = Util.convertUTCToTimezone(this.complaintDetails.submittedDate, this.authService.user.timezoneOffset);
      this.complaintDetails.submittedDate = Util.toLocalInputValue(localSubmittedDate) as any;
    } catch (error) {
      this.snackBar.error('An error occurred while getting complaint details');
      console.log(error, "error getting complaint details");
    }

  }
  ngAfterViewInit(): void {
    this.scrollToBottom(); // Ensure scrolling works after the component initializes
  }

  ngAfterViewChecked(): void {
    this.scrollToBottom(); // Ensure scrolling works if responses are updated dynamically
  }
  scrollToBottom(): void {
    if (this.responseContainer) {
      try {
        this.responseContainer.nativeElement.scrollTop = this.responseContainer.nativeElement.scrollHeight;
      } catch (err) {
        console.error('Failed to scroll:', err);
      }
    }
  }
  public getDatestrings(data: Date) {
    return Util.getUserLocalDateTimeString(data, this.authService.user.timezoneOffset);
  }
  async submitBtnClick() {
    let model = {
      complaintID: this.complaintID,
      reply: this.response,
      examNo: this.complaint.examNo,
      closeComplaint: this.closeCM
    }
    try {
      this.complaintDetails = await this.complaintService.saveComplaintReply(model);
      this.snackBar.success('Reply Sent Successfully');
      if (this.closeCM) {
        this.snackBar.success('Ticket Closed Successfully');
      }
    } catch (error) {
      this.snackBar.error('An error occurred while closing ticket. ' + error);
      console.log(error, "error closing ticket");
    }
  }
  async closeBtnClick() {
    try {
      this.complaintDetails = await this.complaintService.closeComplaint(this.complaintID);
      this.snackBar.success('Ticket Closed Successfully');
    } catch (error) {
      this.snackBar.error('An error occurred while closing Ticket');
      console.log(error, "error closing Ticket");
    }

  }
  copyPlaceholder(text: string, event: MouseEvent) {
    navigator.clipboard.writeText(text);
    // Insert into Quill at cursor position
    this.insertIntoQuill(text);
    const target = event.target as HTMLElement;
    const rect = target.getBoundingClientRect();

    // Position toast beside the span
    this.toast.x = rect.right + 10; // 10px to the right
    this.toast.y = rect.top;

    this.toast.visible = true;

    // Hide after 1.2 seconds
    setTimeout(() => {
      this.toast.visible = false;
    }, 1200);
  }
  onEditorReady(quill: any) {
    this.quill = quill;
  }
  insertIntoQuill(text: string) {
    if (!this.quill) return;

    const range = this.editor.quillEditor.getSelection(true);

    if (range) {
      // Insert text at cursor
      this.editor.quillEditor.insertText(range.index, text);

      // Move cursor to end of inserted text
      this.editor.quillEditor.setSelection(range.index + text.length, 0);
    } else {
      // If no cursor (editor not focused), append at end
      const length = this.editor.quillEditor.getLength();
      this.editor.quillEditor.insertText(length, text);
    }
    this.response = this.quill.root.innerHTML;

  }

}
